export default __webpack_public_path__ + "fonts/NeueEinstellung-Medium.woff2";